module.exports = __webpack_public_path__ + "static/media/RECLAMACIONES_ALT.868e413c.svg";